import { render, staticRenderFns } from "./ConsumptionView.vue?vue&type=template&id=b9de4aba&scoped=true&"
import script from "./ConsumptionView.vue?vue&type=script&lang=js&"
export * from "./ConsumptionView.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionView.vue?vue&type=style&index=0&id=b9de4aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de4aba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer})
